import classNames from 'classnames';
import styles from '../style.module.scss';

/**
 * Hero section: page title, optional hero image, intro paragraphs.
 */
export function VacanciesHero({ config }) {
  return (
    <>
      <h1 className={styles.title}>{config.pageTitle}</h1>
      {config.heroImageUrl && (
        <div className={classNames(styles.mb3, styles.heroImageWrap)}>
          <img
            src={config.heroImageUrl}
            alt={config.heroImageAlt}
            className={styles.heroImage}
          />
        </div>
      )}
      {config.paragraphs.map((text, i) => text && <p key={`p-${i}`}>{text}</p>)}
    </>
  );
}
